import React from 'react';
import TradrMembersTable from '../components/TradrMemberTable';

export function TradrMembers() {
  return <TradrMembersTable />;
}
